import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { IndirectRateRule } from './indirect-rate-rule.model';

export const loadIndirectRateRules = createAction(
    '[IndirectRateRule/API] Load IndirectRateRules',
    props<{ indirectRateRules: IndirectRateRule[] }>()
);

export const addIndirectRateRule = createAction(
    '[IndirectRateRule/API] Add IndirectRateRule',
    props<{ indirectRateRule: IndirectRateRule }>()
);

export const upsertIndirectRateRule = createAction(
    '[IndirectRateRule/API] Upsert IndirectRateRule',
    props<{ indirectRateRule: IndirectRateRule }>()
);

export const addIndirectRateRules = createAction(
    '[IndirectRateRule/API] Add IndirectRateRules',
    props<{ indirectRateRules: IndirectRateRule[] }>()
);

export const upsertIndirectRateRules = createAction(
    '[IndirectRateRule/API] Upsert IndirectRateRules',
    props<{ indirectRateRules: IndirectRateRule[] }>()
);

export const updateIndirectRateRule = createAction(
    '[IndirectRateRule/API] Update IndirectRateRule',
    props<{ indirectRateRule: Update<IndirectRateRule> }>()
);

export const updateIndirectRateRules = createAction(
    '[IndirectRateRule/API] Update IndirectRateRules',
    props<{ indirectRateRules: Update<IndirectRateRule>[] }>()
);

export const deleteIndirectRateRule = createAction(
    '[IndirectRateRule/API] Delete IndirectRateRule',
    props<{ id: string }>()
);

export const deleteIndirectRateRules = createAction(
    '[IndirectRateRule/API] Delete IndirectRateRules',
    props<{ ids: string[] }>()
);

export const clearIndirectRateRules = createAction(
    '[IndirectRateRule/API] Clear IndirectRateRules'
);

export const getIndirectRateRules = createAction(
    '[IndirectRateRule/API] Get IndirectRateRules',
    props<{ rateType: string, costCenter: number }>()

);
